export default __webpack_public_path__ + "static/media/logo05.c0d397a5.svg";